var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVenuesGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C14 4.57 11.35 2 8 2S2 4.57 2 8.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM8 0c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C0 3.22 3.8 0 8 0z",
    fill: "url(#icon_venues_gradient_svg__paint0_linear_2254_72)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_venues_gradient_svg__paint0_linear_2254_72",
    x1: -6.94,
    y1: 9.984,
    x2: 19.657,
    y2: 9.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTBDNi45IDEwIDYgOS4xIDYgOEM2IDYuOSA2LjkgNiA4IDZDOS4xIDYgMTAgNi45IDEwIDhDMTAgOS4xIDkuMSAxMCA4IDEwWk0xNCA4LjJDMTQgNC41NyAxMS4zNSAyIDggMkM0LjY1IDIgMiA0LjU3IDIgOC4yQzIgMTAuNTQgMy45NSAxMy42NCA4IDE3LjM0QzEyLjA1IDEzLjY0IDE0IDEwLjU0IDE0IDguMlpNOCAwQzEyLjIgMCAxNiAzLjIyIDE2IDguMkMxNiAxMS41MiAxMy4zMyAxNS40NSA4IDIwQzIuNjcgMTUuNDUgMCAxMS41MiAwIDguMkMwIDMuMjIgMy44IDAgOCAwWiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzIyNTRfNzIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMjI1NF83MiIgeDE9Ii02LjkzOTgzIiB5MT0iOS45ODM4NCIgeDI9IjE5LjY1NyIgeTI9IjkuOTM0NzEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjMxNzcwOCIgc3RvcC1jb2xvcj0iI0U0MzQyNSIvPgo8c3RvcCBvZmZzZXQ9IjAuNzE4NzUiIHN0b3AtY29sb3I9IiM0NDFGRDgiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMEEyNkI4Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgIconVenuesGradient as ReactComponent };